<template>
  <div id="app">
      <div style="height: 800px;display: flex;flex-direction: column;align-items: center;justify-content: center;background-color: #cccccc;
       border-radius: 10px;border: 1px solid #ccc;">
          <div class="hear-bar" style="height: 100px;margin-top: 10px;background-color: #cccccc;display: flex;align-items: center;justify-content: center;">
              <h1>云票智能体，更懂你！！！</h1>
          </div>
          <div class="chat-bar" style="height: 700px;background-color: #cccccc;display: flex;align-items: center;justify-content: center;">
              <HelloWorld msg="Welcome to Your Vue.js App" style="width: 450px;height: 600px;"></HelloWorld>
          </div>
      </div>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
